import React, { useCallback } from 'react'
import { ProgressBar } from 'devextreme-react/progress-bar'

interface UploadProgressBarProps {
	percent: number
	progressMessage: string
	filename: string
}

export default function UploadProgressBar({ percent, progressMessage, filename }: UploadProgressBarProps) {
	const statusFormat = useCallback(
		(ratio: number) => {
			if (!progressMessage) {
				return 'Waiting...'
			}
			return progressMessage + ' [ ' + Math.round(ratio * 100) + '% ]'
		},
		[progressMessage]
	)

	return (
		<>
			{filename && <small style={{ marginTop: '10px', display: 'block' }}>{filename}</small>}
			{percent > -1 && <ProgressBar min={0} max={100} value={percent} statusFormat={statusFormat} />}
		</>
	)
}
